// API 基础配置
const BASE_URL = '/server/api';

// Token 管理
function getToken() {
  return localStorage.getItem('admin_token');
}

function setToken(token) {
  localStorage.setItem('admin_token', token);
}

function removeToken() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
}

function getUserInfo() {
  const user = localStorage.getItem('admin_user');
  return user ? JSON.parse(user) : null;
}

function setUserInfo(userInfo) {
  localStorage.setItem('admin_user', JSON.stringify(userInfo));
}

// 通用请求方法
async function request(url, options = {}) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  };

  const token = getToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }

  const response = await fetch(BASE_URL + url, config);
  const data = await response.json();

  if (data.code === 401) {
    removeToken();
    window.location.hash = '#/login';
    throw new Error(data.msg);
  }

  if (data.code !== 0 && data.code !== undefined) {
    throw new Error(data.msg || '请求失败');
  }

  return data;
}

export {
  BASE_URL,
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  request,
};
